import React, { useEffect, useState } from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Trans_Data_Report from "./TransDataInt";

const Trans_Data_Abstract = ({ month, year }) => {
    const [data, setData] = useState([]);
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        if (!month || !year) return;

        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_URL_SALE}/api/transData/data`,
                    { params: { month, year } }
                );
                const list = res.data || [];
                setData(list);

                if (list.length > 0) {
                    const fixedColumns = ["datadate", "cnt", "sale", "suc", "fail", "ben_rec"];
                    const dynCols = Object.keys(list[0]).filter((k) => !fixedColumns.includes(k));
                    setDynamicColumns(dynCols);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, [month, year]);

    const handleDateClick = (date) => {
        setSelectedDate(null);
        setShowTable(false);
        setLoading(true);

        setTimeout(() => {
            setSelectedDate(date);
            setLoading(false);
            setShowTable(true);
        }, 3000);
    };

    if (!data || data.length === 0) {
        return (
            <div className="response" style={{ textAlign: "center", marginTop: "20px" }}>
                No Data Found
            </div>
        );
    }

    return (
        <div>
            <table width="50%" border="1" align="center">
                <thead>
                    <tr className="tableheader">
                        <th>SlNo</th>
                        <th>Date</th>
                        <th>BenefTrans</th>
                        <th>Prepared</th>
                        <th>Success</th>
                        <th>Failed</th>
                        <th>Qty in Mts</th>
                        {dynamicColumns.map((col) => (
                            <th key={col}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td align="right">{index + 1}</td>
                            <td>
                                <button
                                    onClick={() => handleDateClick(row.datadate)}
                                    style={{
                                        border: "none",
                                        background: "none",
                                        color: "black",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        padding: 0,
                                        font: "inherit",
                                    }}
                                >
                                    {row.datadate}
                                </button>
                            </td>
                            <td align="right">{row.cnt ?? 0}</td>
                            <td align="right">{row.sale ?? 0}</td>
                            <td align="right">{row.suc ?? 0}</td>
                            <td align="right">{row.fail ?? 0}</td>
                            <td align="right">{row.ben_rec ?? 0}</td>
                            {dynamicColumns.map((col) => (
                                <td key={col}>{row[col] ?? 0}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            {loading && (
                <div align="center" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <CircularProgress />
                </div>
            )}

            {showTable && selectedDate && (
                <div style={{ marginTop: "30px" }}>
                    <Trans_Data_Report month={month} year={year} datadate={selectedDate} />
                </div>
            )}
        </div>
    );
};

export default Trans_Data_Abstract;
